function blob2buffer (blob) {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onabort = reject;
    reader.onerror = reject;
    reader.onload = () => resolve(reader.result);
    reader.readAsArrayBuffer(blob);
  });
}

function fetchBlobByUrl (url) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('get', url, true);
    xhr.responseType = 'blob';
    xhr.onload = function () {
      if (xhr.status === 200) {
        resolve(xhr.response);
      } else {
        reject(new Error('获取Blob失败：' + xhr.status));
      }
    };
    xhr.onerror = reject;
    xhr.send();
  });
}

/**
 * v1加密算法
 * 按位取反
 */
const v1 = {
  scrypt (buffer) {
    const arr = new Uint8Array(buffer);
    function jpg (arr) {
      const len = arr.byteLength;
      let i = 0;
      while (i < len) {
        if (arr[i] === 0xff) {
          // 标记数据忽略下一位
          i++;
        } else {
          // 非标记数据，且不是0（避免与标记位冲突）的按位取反
          arr[i] !== 0x0 && (arr[i] = ~arr[i]);
        }
        i++;
      }
    }
    function png (arr) {
      const len = arr.byteLength;
      let i = 29;
      while (i < len - 12) {
        arr[i] = ~arr[i];
        i++;
      }
    }
    function webp (arr) {
      const len = arr.byteLength;
      let i = 12;
      while (i < len) {
        arr[i] = ~arr[i];
        i++;
      }
    }
    if (arr[0] === 0xff && arr[1] === 0xd8) {
      /**
       * jpg格式说明：
       * （1）开头两个字节为0xff0xd8，以0xff0xd9两个字节为结束标记，尾部可追加数据，不影响展示
       * （2）0xff及紧跟其后的一个字节为控制信息
       */
      jpg(arr);
    } else if ([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a].every((item, index) => item === arr[index])) {
      /**
       * png格式说明：
       * （1）开头固定8字节：[0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]
       * （2）文件头数据块IHDR：8 + 13 = 21字节
       * （3）图像结束数据IEND：12字节
       */
      png(arr);
    } else if (
      [0x52, 0x49, 0x46, 0x46].every((item, index) => item === arr[index]) &&
      [0x57, 0x45, 0x42, 0x50].every((item, index) => item === arr[index + 8])
    ) {
      /**
       * webp格式说明：
       * （1）首部12字节
       *      （a）Chunk FourCC（4字节）：RIFF([0x52, 0x49, 0x46, 0x46])
       *      （b）Chunk Size（4字节）：不固定
       *      （c）Chunk Payload（4字节）：WEBP([0x57, 0x45, 0x42, 0x50])
       */
      webp(arr);
    }

    return arr.buffer;
  }
  // decrypt (buffer) {
  // }
};

// 算法名称 ---> 算法标识
const identifyMap = {
  v1: 'cc8124dd-c419-4aaf-bd72-f8fce8182402'
};

// 算法标识 ----> 算法
const algo = {
  'cc8124dd-c419-4aaf-bd72-f8fce8182402': v1
};

/**
 * 加密方法：algo(buffer) + identify，使用对应加密算法处理文件，文件需全部读取到内存，注意文件尺寸，避免过大
 * @param {File|Blob} file 待加密文件
 * @param {String} algo 加密算法 `v1`
 * @return {Blob} 处理后的文件，不是file对象，使用时需注意
 */
function scrypt (file, version = 'v1') {
  const identify = identifyMap[version];
  return blob2buffer(file)
    .then(buffer => {
      return new Blob([algo[identify].scrypt(buffer), identify], { type: file.type });
    });
}

/**
 * 解密方法
 * @param {Blob|String} blobOrUrl 可以为Blob或http图片地址
 * @returns {Blob}
 */
function decrypt (blobOrUrl) {
  const getBlob = () => {
    if (typeof blobOrUrl === 'string') {
      return fetchBlobByUrl(blobOrUrl);
    }
    return Promise.resolve(blobOrUrl);
  };
  return getBlob()
    .then(blob2buffer)
    .then(buffer => {
      const identify = String.fromCharCode.apply(null, new Uint8Array(buffer.slice(-36)));
      if (!algo[identify]) {
        return new Blob([buffer]);
      }
      const decrypt = algo[identify].decrypt || algo[identify].scrypt;
      return new Blob([decrypt(buffer.slice(0, -36))]);
    });
}

export default { scrypt, decrypt, blob2buffer };
